<template>
  <div id="app" v-if="app">
    <div v-if="pageLoad >= 4">
      <template v-if="$route.name === 'CouponDetail'">
        <router-view></router-view>
      </template>

      <template v-else>

        <template v-if="session.uid > 0 && $route.name !== 'Login'">
          <Header></Header>
          <Sidebar></Sidebar>
          <main class="main">
           <!-- <Breadcumb></Breadcumb> --> 
            <router-view></router-view>
          </main>
        </template>

        <template v-if="$route.name === 'Login'">
          <router-view></router-view>
        </template>
        <PayinModal></PayinModal>

      </template>


    </div>
  </div>
</template>

<script>

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Breadcumb from "./components/Breadcumb";
import PayinModal from "./components/PayinModal";

export default {
  name: 'app',
  components: {PayinModal, Breadcumb, Header, Sidebar},
  data() {
    return {
      app: false,
      pageLoad: 0,
      session: [],
      meta: null,
      isLogged: false,
      t: false,
      accessToken: null,
      refreshToken: null,
      clientId: null,
      clientSecret: null,
      loading: false,
      maintenance: false,
    }
  },
  watch: {
    'app'() {
      this.getClient();
      this.getTranslations();
      this.init();
    },
    accessToken() {
      this.getUserSession();
    },
    isLogged() {
      this.init();
    },
    '$route.name' () {
      this.init();
      window.scroll(0, 0);
      //window.location.reload()
    }
  },
  mounted() {
    if (this.getApp()) {
      this.getClient();
      this.getTranslations();
      this.init();
      this.$root.loading = 0;
    }
    this.$bus.$on('sessionUpdated', (payload) => {
      this.getUserSession();
    });
    this.$bus.$on('accessToken', (payload) => {
      this.getUserSession();
    });
    this.$bus.$on('getClientCheck', (payload) => {
      this.getClient();
    });
    this.$bus.$on('globalLoader', (payload) => {
      this.loading = payload;
    });

    this.$bus.$on('OAUTH_TOKEN', (payload) => {
      window.auth.previousToken = window.auth.accessToken;
      window.accessTokenHeader = payload;
      window.auth.accessToken = payload;
      this.$setItem('auth', window.auth);
      this.$router.replace({name: 'Home', query: {redirect: 'manager'}})
    });

    setInterval(this.getUserSession, 60000);
    setInterval(this.refreshTokenRoll, 3600000);
  },
  methods: {
    init() {
      this.getUserSession();
      this.liveSupportWIdget();
    },
    liveSupportWIdget() {
      window.__lc = window.__lc || {};
      window.__lc.license = 11108272;
      (function () {
        var lc = document.createElement('script');
        lc.type = 'text/javascript';
        lc.async = true;
        lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(lc, s);
      })();
    },
    getTokens() {
      var th = this;
      this.$getItem('auth', function (key, value) {
        return value;
      }, function (err) {
        return false;
      })
    },
    getUserSession(u) {
      var tokens = this.getTokens();
      var th = this;
      this.$getItem('auth', function (key, a) {
        if (!a) {
          window.auth.accessToken = null;
          window.auth.client = null;
        } else {
          window.auth = a;
        }


        th.$http.get(api + 'api/get/session').then(response => {

          th.session = response.body.result.user;
          th.$root.session = response.body.result.user;
          th.meta = response.body.result.app.meta;
          window.session = response.body.result.user;

          if((window.session && window.session.group && window.session.group.key != "ROLE_RESELLER") ||
            window.uid == 0
          ){
            window.session.uid = 0;
            th.$setItem('auth', {});
            th.$setItem('session', {});
            setTimeout(() => {
              window.location.replace('#/login')
            }, 500);
            return
          }

          th.$setItem('session', response.body.result.user);
          window.document.title = th.meta.title;
          if (session.timezone) {
            window.moment.tz.load({
              zones: [],
              links: [session.timezone],
            });
          }

          if (window.session) {
            th.pageLoad += 1;
          }
          th.$bus.$emit('Session', response.body.result.user);
          th.isLogged = (th.$root.session.uid > 0) ? true : false;
          th.$bus.$emit('globalLoader', false);

          if(session.uid == 0)
            th.$router.push({name: 'Login'});

        }, response => {

          th.pageLoad += 1;

          if ((response.status == 404 || response.status == 401) && th.app) {
            th.$bus.$emit('globalLoader', false);
            th.$setItem('auth', {});
            window.session = null;
            th.$router.push({name: 'Login'});
          }
        });
      }, function (err) {
        th.$bus.$emit('globalLoader', false);
        th.$setItem('auth', {});
        th.$router.push({name: 'Login'});
        return false;
      })
    },
    refreshTokenRoll() {
      var th = this;
      this.$getItem('auth', function (key, value) {

        if (value) {
          th.$http.get(api + 'oauth/v2/token',
              {
                params: {
                  client_id: value.client,
                  client_secret: value.clientSecret,
                  grant_type: 'refresh_token',
                  refresh_token: value.refreshToken
                }
              }).then(
              response => {
                window.accessTokenHeader = response.body.access_token;
                window.auth.accessToken = response.body.access_token;
                window.auth.refreshToken = response.body.refresh_token;
                th.$setItem('auth', window.auth);
              }, response => {
                window.auth = null;
                windows.session = null;
                th.$router.push('/');
              });
        }
      }, function (err) {
      })
    },
    domainCleaner (domain)
			{
				var subdomain								= 'xkart.';
				var subdomainLen							= subdomain.length;

				if (domain.substr(subdomain, subdomainLen) == subdomain)
				{
					domain									= domain.substring(subdomainLen)
				}

				return domain;
			},
    getApp() {
      var hostname = this.domainCleaner(window.location.hostname);
      if (hostname == 'localhost') {
        hostname = this.domainCleaner(window.apphost);
      }

      this.$http.get(bsapi + 'api/getAppByHostname/' + hostname).then(response => {
        var app = response.body.app;
        if (app) {
          var socketProtocol = (window.location.protocol === 'https:') ? 'wss://' : 'ws://';
          window.api = window.scheme + '//' + app.hostname + '/';
          window.wsapi = socketProtocol + app.hostname;
          this.$root.app = app;
          this.app = app;
          this.pageLoad += 1;
          this.maintenance = false;

          if (window.location.hostname == 'localhost') {
           // window.api = window.scheme + '//sp.co:98/';
          }
        }
        if (response.status != 200) {
          this.maintenance = true;
        }
      }, response => {
        this.maintenance = true;
      });
    },
    getClient() {
      this.accessToken = window.auth.accessToken;
      if (!this.accessToken) {
        this.$http.get(api + 'api/v1/get/client').then(response => {
          this.clientId = response.body.client_id;
          this.clientSecret = response.body.client_secret;
          window.auth.client = response.body.client_id;
          window.auth.clientSecret = response.body.client_secret;
          this.$setItem('auth', window.auth);
        }, response => {
          this.maintenance = true;
          this.error_msg = 'Client couldnt receiver the response.'
        });
      }
    },
    getTranslations() {
      this.$http.get(bsapi + 'api/v1/translations/get/all',
      ).then(response => {
        this.t = response.body.result.translation;
        this.$root.t = this.t;
        this.pageLoad += 1;
        window.moment.locale(window.locale);
        var NowMoment = moment().format("dddd, MMMM Do");
      }, response => {
        if (response.status != 200) {
          this.maintenance = true;
        }
      })
    },
    sessionStop() {
      this.$cookie.delete('client_id');
      this.$cookie.delete('client_secret');
      window.location.reload();
    },
    openForgot() {
      this.$refs.fpmodal.open();
    }
  }

}
</script>

<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/App.vue